import {TUTORIAL_MATCH_STATUSES} from '../../constants/tutorialMatch.js';
import {LOCAL_MATCH_STATUSES} from '../../constants/localMatch.js';

/**
 * Недоигранное обучение: запись создана на старте главы, а глава так и не
 * пройдена. В истории матчей профиля и в деталях матча такие записи видят
 * все — с пометкой «Не завершено». Админскими остаются запись прохождения
 * (реплей) и общий список всех матчей (GET /api/admin/matches).
 *
 * Запись без статуса (старые записи обучения писались только по завершении
 * главы) недоигранной не считается.
 */
export const checkIfUnfinishedTutorialMatch = (match) => (
  Boolean(match?.isTutorial) && match.tutorialStatus === TUTORIAL_MATCH_STATUSES.IN_PROGRESS
);

/**
 * Незавершенная локальная партия: запись создана на старте партии, а итоги
 * так и не подведены. Как и недоигранное обучение, в истории матчей профиля и
 * в деталях матча она видна всем — без мест и очков, с пометкой «Не завершён».
 *
 * Матч без статуса (сохраненный только по итогам — все старые и клиенты без
 * записи) незавершенным не считается.
 */
export const checkIfUnfinishedLocalMatch = (match) => (
  Boolean(match?.isLocal) && match.localStatus === LOCAL_MATCH_STATUSES.IN_PROGRESS
);

// То же условие в виде выборки Mongo: по нему витрина главного меню не берет
// незавершенные партии (GET /api/matches/random-replay)
export const UNFINISHED_LOCAL_MATCH_CONDITION = Object.freeze({
  isLocal: true,
  localStatus: LOCAL_MATCH_STATUSES.IN_PROGRESS,
});
